import { StyleSetup, StyleSetupReceive } from "../models/style";

//AVCDAMOSHI.001  17/03/2025  Add code for Reuse style setupweb
export const initialStyleSetup: Partial<StyleSetup> = {

    consent_page_style_body: {
        "border-color": "",
        "border-radius": "",
        "border": "",
        "color": "",
        "font-family": "",
        "font-size": "",
        "font-weight": "",
        "backgroundColor": ""
    },
    consent_page_style_header: {
        "border-color": "",
        "border-radius": "",
        "border": "",
        "color": "",
        "font-family": "",
        "font-size": "",
        "font-weight": "",
        "backgroundColor": ""
    },
    consent_page_style_footer: {
        "border-color": "",
        "border-radius": "",
        "border": "",
        "color": "",
        "font-family": "",
        "font-size": "",
        "font-weight": "",
        "backgroundColor": ""
    },
    icon_style: {
        "border-color": "",
        "border-radius": "",
        "border": "",
        "color": "",
        "font-family": "",
        "font-size": "",
        "font-weight": "",
        "backgroundColor": ""
    },
    title_style: {
        "border-color": "",
        "border-radius": "",
        "border": "",
        "color": "",
        "font-family": "",
        "font-size": "",
        "font-weight": "",
        "backgroundColor": ""
    },
    title2_style: {
        "border-color": "",
        "border-radius": "",
        "border": "",
        "color": "",
        "font-family": "",
        "font-size": "",
        "font-weight": "",
        "backgroundColor": ""
    },
    caption_style: {
        "border-color": "",
        "border-radius": "",
        "border": "",
        "color": "",
        "font-family": "",
        "font-size": "",
        "font-weight": "",
        "backgroundColor": ""
    },
    input_data_style: {
        "border-color": "",
        "border-radius": "",
        "border": "",
        "color": "",
        "font-family": "",
        "font-size": "",
        "font-weight": "",
        "backgroundColor": ""
    },
    confirm_button_style: {
        "border-color": "",
        "border-radius": "",
        "border": "",
        "color": "",
        "font-family": "",
        "font-size": "",
        "font-weight": "",
        "backgroundColor": ""
    },
    cancel_button_style: {
        "border-color": "",
        "border-radius": "",
        "border": "",
        "color": "",
        "font-family": "",
        "font-size": "",
        "font-weight": "",
        "backgroundColor": ""
    },
    general_button_style: {
        "border-color": "",
        "border-radius": "",
        "border": "",
        "color": "",
        "font-family": "",
        "font-size": "",
        "font-weight": "",
        "backgroundColor": ""
    },
    confirm_message_box_style: {
        "border-color": "",
        "border-radius": "",
        "border": "",
        "color": "",
        "font-family": "",
        "font-size": "",
        "font-weight": "",
        "backgroundColor": ""
    },
    success_message_box_style: {
        "border-color": "",
        "border-radius": "",
        "border": "",
        "color": "",
        "font-family": "",
        "font-size": "",
        "font-weight": "",
        "backgroundColor": ""
    },
    error_message_box_style: {
        "border-color": "",
        "border-radius": "",
        "border": "",
        "color": "",
        "font-family": "",
        "font-size": "",
        "font-weight": "",
        "backgroundColor": ""
    },
    consent_page_style: {
        "border-color": "",
        "border-radius": "",
        "border": "",
        "color": "",
        "font-family": "",
        "font-size": "",
        "font-weight": "",
        "backgroundColor": ""
    },
    title_consent_style: {
        "border-color": "",
        "border-radius": "",
        "border": "",
        "color": "",
        "font-family": "",
        "font-size": "",
        "font-weight": "",
        "backgroundColor": ""
    },
    description_consent_style: {
        "border-color": "",
        "border-radius": "",
        "border": "",
        "color": "",
        "font-family": "",
        "font-size": "",
        "font-weight": "",
        "backgroundColor": ""
    },
    title_message_box_style: {
        "border-color": "",
        "border-radius": "",
        "border": "",
        "color": "",
        "font-family": "",
        "font-size": "",
        "font-weight": "",
        "backgroundColor": ""
    },
    description_confirm_message_box_style: {
        "border-color": "",
        "border-radius": "",
        "border": "",
        "color": "",
        "font-family": "",
        "font-size": "",
        "font-weight": "",
        "backgroundColor": ""
    },
    general_button_style_hover_active_style: {
        "border-color": "",
        "border-radius": "",
        "border": "",
        "color": "",
        "font-family": "",
        "font-size": "",
        "font-weight": "",
        "backgroundColor": ""
    },
    agree_box_consent: {
        "border-color": "",
        "border-radius": "",
        "border": "",
        "color": "",
        "font-family": "",
        "font-size": "",
        "font-weight": "",
        "backgroundColor": ""
    },
    member_detail_box: {
        "border-color": "",
        "border-radius": "",
        "border": "",
        "color": "",
        "font-family": "",
        "font-size": "",
        "font-weight": "",
        "backgroundColor": ""
    },
    member_name: {
        "border-color": "",
        "border-radius": "",
        "border": "",
        "color": "",
        "font-family": "",
        "font-size": "",
        "font-weight": "",
        "backgroundColor": ""
    },
    member_tel_and_point: {
        "border-color": "",
        "border-radius": "",
        "border": "",
        "color": "",
        "font-family": "",
        "font-size": "",
        "font-weight": "",
        "backgroundColor": ""
    },
    member_cancel_button_style: {
        "border-color": "",
        "border-radius": "",
        "border": "",
        "color": "",
        "font-family": "",
        "font-size": "",
        "font-weight": "",
        "backgroundColor": ""
    },
    background_Style: {
        "border-color": "",
        "border-radius": "",
        "border": "",
        "color": "",
        "font-family": "",
        "font-size": "",
        "font-weight": "",
        "backgroundColor": ""
    },
    foreground_Style: {
        "border-color": "",
        "border-radius": "",
        "border": "",
        "color": "",
        "font-family": "",
        "font-size": "",
        "font-weight": "",
        "backgroundColor": ""
    },
    member_nearly_exp_point_style: {
        "border-color": "",
        "border-radius": "",
        "border": "",
        "color": "",
        "font-family": "",
        "font-size": "",
        "font-weight": "",
        "backgroundColor": ""
    },
    coupon_header_style: {
        "border-color": "",
        "border-radius": "",
        "border": "",
        "color": "",
        "font-family": "",
        "font-size": "",
        "font-weight": "",
        "backgroundColor": ""
    },
    coupon_header2_style: {
        "border-color": "",
        "border-radius": "",
        "border": "",
        "color": "",
        "font-family": "",
        "font-size": "",
        "font-weight": "",
        "backgroundColor": ""
    },
    coupon_caption_header_style: {
        "border-color": "",
        "border-radius": "",
        "border": "",
        "color": "",
        "font-family": "",
        "font-size": "",
        "font-weight": "",
        "backgroundColor": ""
    }
}

export const styleSetupConfig = (
    styleSetup?: Partial<StyleSetupReceive>, 
    callback?: ((style: StyleSetup) => Partial<StyleSetup>) | (() => Partial<StyleSetup>)) : StyleSetup => {
    if(!styleSetup) return initialStyleSetup as StyleSetup;
    const newSetup = Object.entries(initialStyleSetup).reduce((acc, [K, value]) => {
        if(K === "consent_page_style_body" || K === "consent_page_style_header" || K === "consent_page_style_footer") {
            acc[K] = {
                "border-color": styleSetup.consent_page_style?.border_color ?? value["border-color"],
                "border-radius": styleSetup.consent_page_style?.border_radius ?? value["border-radius"],
                "border": styleSetup.consent_page_style?.border ?? value["border"],
                "color": styleSetup.consent_page_style?.font_color ?? value["color"],
                "font-family": styleSetup.consent_page_style?.font_name ?? value["font-family"],
                "font-size": styleSetup.consent_page_style?.font_size ?? value["font-size"],
                "font-weight": styleSetup.consent_page_style?.font_weight ?? value["font-weight"],
                "backgroundColor": styleSetup.consent_page_style?.background_color ?? value["backgroundColor"],
            };
        } else {
            const key = K as keyof StyleSetupReceive;
            acc[key] = {
                "border-color": styleSetup[key]?.border_color ?? value["border-color"],
                "border-radius": styleSetup[key]?.border_radius ?? value["border-radius"],
                "border": styleSetup[key]?.border ?? value["border"],
                "color": styleSetup[key]?.font_color ?? value["color"],
                "font-family": styleSetup[key]?.font_name ?? value["font-family"],
                "font-size": styleSetup[key]?.font_size ?? value["font-size"],
                "font-weight": styleSetup[key]?.font_weight ?? value["font-weight"],
                "backgroundColor": styleSetup[key]?.background_color ?? value["backgroundColor"],
            };
        }
        return acc;
    }, {} as StyleSetup);

    return callback ? {...newSetup, ...callback(newSetup)} : newSetup;
}
//C-AVCDAMOSHI.001  17/03/2025  Add code for Reuse style setupweb
